import { execFileSync } from 'node:child_process'
import fs from 'node:fs'
import path from 'node:path'
import { normalizeLineEndings } from '@core-engine/snapshots/store.js'

const BIOME_FORMAT_TIMEOUT_MS = 15_000
const BIOME_CONFIG_FILES = ['biome.json', 'biome.jsonc']
const BIOME_FORMATTABLE_EXTENSIONS = new Set([
  '.cjs',
  '.css',
  '.cts',
  '.js',
  '.json',
  '.jsonc',
  '.jsx',
  '.mjs',
  '.mts',
  '.ts',
  '.tsx'
])

function findBiomeBin(cwd: string): string | null {
  const biomeBin = path.join(
    cwd,
    'node_modules',
    '.bin',
    process.platform === 'win32' ? 'biome.cmd' : 'biome'
  )
  return fs.existsSync(biomeBin) ? biomeBin : null
}

function findBiomeConfig(cwd: string): string | null {
  for (const fileName of BIOME_CONFIG_FILES) {
    const configPath = path.join(cwd, fileName)
    if (fs.existsSync(configPath)) {
      return configPath
    }
  }

  return null
}

function canFormatWithBiome(filePath: string): boolean {
  return BIOME_FORMATTABLE_EXTENSIONS.has(path.extname(filePath))
}

export function formatContentForSnapshotMerge(
  cwd: string,
  filePath: string,
  content: string
): string | null {
  if (!canFormatWithBiome(filePath)) {
    return null
  }

  const biomeBin = findBiomeBin(cwd)
  if (!biomeBin) {
    return null
  }

  const configPath = findBiomeConfig(cwd)
  const targetPath = path.join(cwd, ...filePath.split('/'))

  try {
    return execFileSync(
      biomeBin,
      [
        'check',
        '--write',
        '--stdin-file-path',
        targetPath,
        ...(configPath ? ['--config-path', configPath] : [])
      ],
      {
        cwd,
        encoding: 'utf-8',
        input: normalizeLineEndings(content),
        stdio: ['pipe', 'pipe', 'ignore'],
        timeout: BIOME_FORMAT_TIMEOUT_MS
      }
    )
  } catch {
    return null
  }
}
